import React from "react"

import { CircularProgress } from "@material-ui/core"

export const Loading = () => {
  return (<CircularProgress color="secondary" size={128} style={{position: "absolute", top: "calc(50% - 64px)", left: "calc(50% - 64px)"}}/>)
}

export default Loading;